import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { InputControl, InputElement, InputLabel } from '../utils/Input';
import { slugify } from '../../utils/helpers';
var TextArea = /*#__PURE__*/React.forwardRef(function TextArea(_ref, ref) {
  var label = _ref.label,
      invalid = _ref.invalid,
      required = _ref.required,
      disabled = _ref.disabled,
      hidden = _ref.hidden,
      id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'outline' : _ref$variant,
      rest = _objectWithoutPropertiesLoose(_ref, ["label", "invalid", "required", "disabled", "hidden", "id", "name", "value", "variant"]);

  var identifier = id || name || slugify(label);
  return /*#__PURE__*/React.createElement(InputControl, {
    variant: variant,
    invalid: invalid,
    disabled: disabled,
    required: required,
    hidden: hidden
  }, /*#__PURE__*/React.createElement(InputElement, _extends({
    as: TextareaAutosize,
    id: identifier,
    name: name,
    value: value
  }, rest, {
    ref: ref
  })), /*#__PURE__*/React.createElement(InputLabel, {
    raised: !!value,
    htmlFor: identifier
  }, label));
});
export default /*#__PURE__*/React.memo(TextArea);